import React, { useState, useEffect } from "react";
import { CommonInput } from "../common";
import { DeliveryPartner } from "../../types/interfaces";
import useAxios from "../../hooks/useAxios";


type ModalProps = {
  show: boolean;
  handleModalOpenClose: (show: boolean) => void;
  partner?: DeliveryPartner | null;
  getListData: () => void;
};

const CreateUpdateCategory: React.FC<ModalProps> = ({ show, handleModalOpenClose, partner, getListData }) => {
  const axiosInstance = useAxios();
  const [errors, setErrors] = useState<Partial<DeliveryPartner>>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState<DeliveryPartner>({
    _id: "",
    name: "",
    tracking_url: "",
    description: "",
  });
  const [isFormChanged, setIsFormChanged] = useState<boolean>(false);

  useEffect(() => {
    if (partner) {
      setFormData((prev) => ({
        ...prev,
        _id: partner._id ?? "",
        name: partner.name ?? "",
        tracking_url: partner.tracking_url ?? "",
        description: partner.description ?? "",
      }));
    }
  }, [partner]);

  /*Handle Form Element Value Changed*/
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setErrors((prev) => ({ ...prev, [name]: undefined }));
    setFormData((prev) => ({ ...prev, [name]: value }));
    setIsFormChanged(true);
  };

  /*Validate Form*/
  const validate = (): boolean => {
    const newErrors: Partial<DeliveryPartner> = {};
    if (!formData.name) {
      newErrors.name = "Title is required";
    }
    if (!formData.tracking_url) {
      newErrors.tracking_url = "Tracking URL is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /*Submit Form*/
  const handleSubmit = async () => {
    if (validate()) {
      setIsSubmitting(true);
      try {
        const response: any = await axiosInstance({
          url: "deliver-partner/create-update",
          method: "POST",
          data: formData,
        });
        //console.log('create/update response', response.data)
        //on success close the modal
        if (!response.error) {
		  getListData();	
          handleClose();
        }
      } catch (error: any) {
        //console.error('Error in api request:', error);
        if (error?.response?.data?.type === "validation_error") {
          let errors = error.response.data.message.errors; // API returned an error message
          setErrors(errors);
        }
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleClose = () => {
    const newErrors: Partial<DeliveryPartner> = {};
    setErrors(newErrors);
    setFormData({ _id: "", name: "", tracking_url: "", description: "" });
    handleModalOpenClose(false);
  };

  return (
    <>
	  <div
        className="modal fade show"
        tabIndex={-1}
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered mw-650px">
          <div className="modal-content position-relative">
            {/* Close button */}
            <button
              type="button"
              className="btn btn-icon btn-active-color-primary position-absolute"
              style={{ top: "10px", right: "10px", zIndex: 10 }}
              onClick={handleClose}
            >
              ✖
            </button>
			  <div className="modal-header">
				<h2>{partner ? "Update Delivery Partner" : "Create Delivery Partner"}</h2>
			  </div>
			  <div className="modal-body mx-xl-5">
				<form className="form">
				  <label className="required fs-6 fw-semibold form-label mb-1">
					Name
				  </label>
				  <CommonInput
					type="text"
					name="name"
					placeholder="Enter Name"
					value={formData.name}
					onChange={handleInputChange}
					error={errors.name}
					limit={50}
				  />
				  <label className="required fs-6 fw-semibold form-label mb-1">
					Tracking URL
				  </label>
				  <CommonInput
					type="text"
					name="tracking_url"
					placeholder="Enter Tracking URL"
					value={formData.tracking_url}
					onChange={handleInputChange}
					error={errors.tracking_url}
					limit={50}
				  />
				  <label className="required fs-6 fw-semibold form-label mb-1">
					Description
				  </label>
				  <CommonInput
					type="text"
					name="description"
					placeholder="Enter description"
					value={formData.description}
					onChange={handleInputChange}
					error={errors.description}
					className={`form-control form-control-solid ${
					  errors.description ? "is-invalid" : ""
					}`}
				  />

				  <div className="border-top mb-2" />
				  <div className="text-center">
					<button
					  type="button"
					  className="btn btn-light me-3"
					  onClick={handleClose}
					>
					  Cancel
					</button>
					{isSubmitting ? (
					  <button
						type="button"
						id="kt_modal_new_card_submit"
						className="btn btn-primary"
						disabled={true}
					  >
						<span
						  className="indicator-progress"
						  style={{ display: "block" }}
						>
						  Please wait...
						  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
						</span>
					  </button>
					) : (
					  <button
						type="button"
						id="kt_modal_new_card_submit"
						className="btn btn-primary"
						onClick={handleSubmit}
					  >
						<span className="indicator-label">Submit</span>
					  </button>
					)}
				  </div>
				</form>
			  </div>
			</div>
         </div>
      </div>
	  <div className="modal-backdrop fade show" />
    </>
  );
};

export default CreateUpdateCategory;
